import styled from "styled-components";

export const WithdrawContainer = styled.div`
  margin: 15px;
`;
export const WithdrawCard = styled.div``;

export const WithdrawInput = styled.input`
  width: fill-available;
  height: 50px;
  padding-inline: 10px 80px;
  border-radius: 0;
  margin-inline: auto;
`;

export const PinModalInput = styled.input`
  width: fill-available;
  height: 50px;
  padding-inline: 10px;
  border-radius: 0;
  margin-inline: auto;
`;

export const WithdrawButton = styled.button`
  width: 50%;
  height: 50px;
  margin-block-end: 10px;
  margin-inline: auto;
  cursor: pointer;
  border-radius: 10px;
`;
